import React from "react";
import PropTypes from "prop-types";
import Check from "../../assets/img/icons/icon-check.svg";

function ConfirmDialog({
  headerContent,
  bodyContent,
  buttonActionContent,
  onHideAction,
  onDeleteEmail,
  onResetToDefault,
}) {
  const clickAction = React.useCallback(() => {
    if (buttonActionContent === "Delete") {
      onDeleteEmail();
      return onHideAction();
    }

    if (buttonActionContent === "Reset") {
      onResetToDefault();
      return onHideAction();
    }

    return null;
  }, [buttonActionContent, onDeleteEmail, onResetToDefault, onHideAction]);
  return (
    <div>
      <div className="pp_confirm_dialog_bg">
        <div className="pp_confirm_dialog_content">
          <div className="pp_confirm_dialog_content_header">
            {headerContent}
          </div>
          <div className="pp_confirm_dialog_content_body">{bodyContent}</div>
          <div className="pp_confirm_dialog_content_controls">
            <button
              type="button"
              className="pp_confirm_dialog_content_cancel_button"
              onClick={onHideAction}
            >
              Cancel
            </button>
            <button
              type="button"
              className="pp_confirm_dialog_content_action_button"
              onClick={clickAction}
            >
              <Check />
              {buttonActionContent}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ConfirmDialog.propTypes = {
  headerContent: PropTypes.string.isRequired,
  bodyContent: PropTypes.string.isRequired,
  buttonActionContent: PropTypes.string.isRequired,
  // onButtonAction: PropTypes.func.isRequired,
  onDeleteEmail: PropTypes.func.isRequired,
  onResetToDefault: PropTypes.func.isRequired,
  onHideAction: PropTypes.func.isRequired,
};

export default ConfirmDialog;
